import { store } from 'redux/store';
import { format } from 'date-fns';

import { getLastOperation } from '../api/getLastOperation';

type GetOperationDateLimitProps = {
  societyId: string;
  onChangeOperationLimit?: (date: string) => void; // eslint-disable-line
  onChangeLastOperationDate?: (date: string) => void; // eslint-disable-line
};

const defaultLastDate = '1990-01-01T00:00';
const defaultLastDateShort = '1990-01-01';

export const getOperationDateLimit = async ({
  societyId,
  onChangeOperationLimit,
  onChangeLastOperationDate,
}: GetOperationDateLimitProps) => {
  if (!societyId) {
    return;
  }

  try {
    const lastOperation = await store.dispatch(getLastOperation({ societyId }));

    if (!lastOperation) {
      return;
    }

    const lastDate = format(new Date(lastOperation.date), "yyyy-MM-dd'T'HH:mm");
    const dateLimit = format(new Date(lastOperation.date), 'yyyy-MM-dd');

    if (onChangeOperationLimit) {
      onChangeOperationLimit(dateLimit);
    }

    if (onChangeLastOperationDate) {
      onChangeLastOperationDate(lastDate || defaultLastDate);
    }
  } catch {
    if (onChangeOperationLimit) {
      onChangeOperationLimit(defaultLastDateShort);
    }
    if (onChangeLastOperationDate) {
      onChangeLastOperationDate(defaultLastDate);
    }
  }
};
